<template>
  <div class="fancy-header">
      <div class="overlay"></div>
  </div>
</template>
<script>
export default {
    name:'FancyHeader',
}
</script>
<style lang="scss">
      @import "src/assets/sass/shared.scss";
  .fancy-header{
     position: relative;
     width:100%;
     min-height: 180px;
     background:url('/src/assets/img/pexels-photo-216632.jpeg') transparent center  no-repeat fixed;
    background-size:cover;
    -webkit-background-size:cover;
    -moz-background-size:cover;
    -ms-background-size:cover;
    -o-background-size:cover;
    

        .overlay{
            @include overlay-layer(rgba(#000,0.5));
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/fancy-header.vue